/* global globals */
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

module.exports = {
  loadDeleteMeData() {
    const data = get(globals, 'delete_me_data', null);
    if (!data) {
      return;
    }

    AppDispatcher.dispatch({
      type: ActionTypes.DELETE_ME_DATA_LOAD_SUCCESS,
      data,
    });
  },
};
